<template>
	<BRow class="checkout-desktop">
		<BCol cols="12" lg="7">
			<KeepAlive>
				<CountdownTimer
					v-if="countdownDuration"
					:duration="countdownDuration"
				/>
			</KeepAlive>

			<ShippingBanner/>
			<BlacklistBanner/>
			<ProductLimitBanner/>

			<FormSections/>
			<Reviews v-if="reviewItems.length" :reviews="reviewItems"/>
		</BCol>

		<BCol cols="12" lg="4" offset-lg="1">
			<div class="checkout-desktop__right">
				<OrderSummary/>
				<SimpleTrustBanner/>
				<Carousel
					v-if="carouselItems.length"
					:items="carouselItems"
					:description="carouselDescription"
				/>
			</div>
		</BCol>
	</BRow>
</template>

<script>
import {
	CountdownTimer,
	Carousel,
	Reviews,
} from '@component/user-backend/Checkout/V4/addons';
import OrderSummary from '@component/user-backend/Checkout/V4/OrderSummary.vue';
import SimpleTrustBanner from '@component/user-backend/Checkout/V4/banners/SimpleTrustBanner.vue';
import BlacklistBanner from '@component/user-backend/Checkout/V4/sections/banners/BlacklistBanner.vue';
import ShippingBanner from '@component/user-backend/Checkout/V4/sections/banners/ShippingBanner.vue';
import FormSections from './sections/FormSections.vue';
import ProductLimitBanner from './sections/banners/ProductLimitBanner.vue';

export default {
	components: {
		ProductLimitBanner,
		OrderSummary,
		CountdownTimer,
		Carousel,
		Reviews,
		FormSections,
		SimpleTrustBanner,
		BlacklistBanner,
		ShippingBanner,
	},

	props: {
		countdownDuration: {
			type: Number,
			default: 0,
		},
		carouselItems: {
			type: Array,
			default: () => [],
		},
		carouselDescription: {
			type: String,
			default: '',
		},
		reviewItems: {
			type: Array,
			default: () => [],
		},
	},

	mounted() {
		const content = document.querySelector('.content');
		if (content) content.style.overflow = 'unset';
	},
};
</script>

<style lang="scss" scoped>
.checkout-desktop {
	&__right {
		display: flex;
		flex-direction: column;
		gap: 20px;
		position: sticky;
		top: var(--size-lg);

		> * {
			&:not(:last-child) {
				padding-bottom: 20px;
				border-bottom: 1px solid var(--gray-200);
			}
		}
	}
}
</style>
